<div class="modal-header">
    <h5 class="modal-title">Ajouter un utilisateur</h5>
    <button type="button" class="btn-close btn-primary" aria-label="Close" (click)='fermerModal()'></button>
  </div>
  <div class="modal-body">
    <div class="user-form">
      <div class="row">
        <div class="col-6 mb-2">
          <label for="nom">Nom</label>
          <input id="nom" class="form-control" [formControl]="nomControl" type="text" placeholder="Nom">
          <div *ngIf="nomControl.invalid && nomControl.touched" class="invalid-feedback">
            Nom est requis.
          </div>
        </div>
        <div class="col-6 mb-2">
          <label for="prenom">Prénom</label>
          <input id="prenom" class="form-control" [formControl]="prenomControl" type="text" placeholder="Prénom">
          <div *ngIf="prenomControl.invalid && prenomControl.touched" class="invalid-feedback">
            Prénom est requis.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mb-2">
          <label for="email">Email</label>
          <input id="email" class="form-control" [formControl]="emailControl" type="email" placeholder="Email">
          <div *ngIf="emailControl.invalid && emailControl.touched" class="invalid-feedback">
            Email est requis et doit être valide.
          </div>
        </div>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="admin" [formControl]="adminControl">
        <label class="form-check-label" for="admin">
          Administrateur
        </label>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex flex-column align-items-stretch">
    <div class="row">
      <div class="col-9">
        <button type="button" class="btn btn-modal btn-danger" (click)='fermerModal()'>Fermer</button>
      </div>
      <div class="col-3">
        <button type="submit" class="btn btn-modal btn-primary" [disabled]="nomControl.invalid || prenomControl.invalid || emailControl.invalid" (click)='onSubmit()'>
          Valider
          <div *ngIf="formModalIsSubmitting" class="col-3 text-center spinner-border text-success" role="status"></div>
        </button>
      </div>
    </div>
  </div>
  